import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import MainTour from './tours/Main';
import http from 'http';
import https from 'https';
import { browserHistory } from 'react-router';
import Helmet from "react-helmet";
import Translate from './layout/Translate';
import ClickOutside from 'react-click-outside';

import * as toursActions from '../actions/tours';
import * as userActions from '../actions/user';


var urlParams = {};




class Tours extends Component {

    componentDidMount() {
        this.props.toursActions.fetchDestinationsIfNeeded()
    }

    onBtnClick() {
        this.props.toursActions.fetchToursIfNeeded(1, 1)
    }


    nextTour() {
        this.props.toursActions.nextTour()
    }
    prevTour() {
        this.props.toursActions.prevTour()
    }
    testLang() {
        this.props.toursActions.getLang()
    }
    whoAmI() {
        this.props.userActions.whoAmI()
    }
    logout() {
        this.props.userActions.logout()
    }

    selectTour() {
        browserHistory.push('/map');
    }



    toggleCategories() {
        this.props.toursActions.toggleCategories();
    }

    closeCategories() {
        //console.log('close');
        if (this.props.showCategories) {
            this.props.toursActions.toggleCategories();
        }
    }
    selectDestination (destination, e) {
        this.props.toursActions.selectMainDestination(destination);
        this.props.toursActions.toggleCategories();
        if (!this.props.filterMode || this.props.filterMode == 'd') {
            if (destination.id) {
                this.props.toursActions.toursSearchByMode('d', destination.id);
            } else if (this.props.type.id) {
                this.props.toursActions.toursSearchByMode('t', this.props.type.id);
            } else {
                this.props.toursActions.fetchFeaturedTours();
            }
        }
        // //console.info(e)
        //  console.info(destination)
    }
    selectType (type, e) {
        this.props.toursActions.selectMainType(type);
        this.props.toursActions.toggleCategories();
        //console.log('MODE - ', this.props.filterMode);
        if (!this.props.filterMode || this.props.filterMode == 't') {
            if (type.id) {
                this.props.toursActions.toursSearchByMode('t', type.id);
            } else if (this.props.destination.id) {
                this.props.toursActions.toursSearchByMode('d', this.props.destination.id);
            } else {
                this.props.toursActions.fetchFeaturedTours();
            }
        }
        // console.info(e)
        //  console.info(destination)
    }


    render () {
        const { list, destinations, showCategories, activeTour, types, activities, destination, type, filterMode, tourMenu, menuTours, width } = this.props;


        let photoSize = 1400;
        let sizes = [2560, 1920, 1400, 1000];
        sizes.forEach(function(size){
            if (width && width <= size) {
                photoSize = size;
            }
        });


        //console.info(100000);
        return (
            <div>

                <MainTour tour={menuTours[activeTour]} photoSize={photoSize} show={true} lang={this.props.user.lang} tourMenu={tourMenu} menuTours={menuTours} filterMode={filterMode} destination={destination} type={type} destinations={destinations} activities={activities} types={types} actions={this.props.toursActions} showCategories={showCategories} toursActions={this.props.toursActions} toggleCategories={this.props.toursActions.toggleCategories} nextTour={this.props.toursActions.nextTour} selectTour={this.props.toursActions.selectTour} selectDestination={this.props.toursActions.selectDestination} />

                {menuTours.map((tour, i)=>
                    <div>
                        {activeTour!=i &&
                            <MainTour key={i} tour={tour} show={false} lang={this.props.user.lang} tourMenu={tourMenu} menuTours={menuTours} filterMode={filterMode} destination={destination} type={type} destinations={destinations} activities={activities} types={types} actions={this.props.toursActions} showCategories={showCategories} toursActions={this.props.toursActions} toggleCategories={this.props.toursActions.toggleCategories} nextTour={this.props.toursActions.nextTour} selectTour={this.props.toursActions.selectTour} selectDestination={this.props.toursActions.selectDestination} />
                        }
                        {tour.coverImages && tour.coverImages.previews && tour.coverImages.previews['browsing' + photoSize] &&
                            <div className="main__preview">
                                <img src={
                                    (tour.coverImages && tour.coverImages.previews['browsing' + photoSize])?tour.coverImages.previews['browsing' + photoSize]:''
                                 } />
                            </div>
                        }
                        
                    </div>
                )}





            </div>
        );
    }
}


Tours.need = [
    {
        action: toursActions.fetchDestinations
    }
];




function mapStateToProps(state) {
    let { tours, postsByTour } = state;
    tours = tours;


    return {
        list: state.tours.list,
        destinations: state.tours.destinations,
        destination: state.tours.mainDestination,
        types: state.tours.types,
        type: state.tours.mainType,
        activities: state.tours.activities,
        showCategories: state.tours.showCategories,
        activeTour: state.tours.activeTour,
        filterMode: state.tours.filterMode,
        tourMenu: state.tours.tourMenu,
        menuTours: state.tours.menuTours,
        user: state.user
    };
}


function mapDispatchToProps(dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Tours)





// WEBPACK FOOTER //
// ./src/common/components/Tours.js